import { useRef, useState } from "react";
import { adminRequest, operationKey } from "lib/adminSiteApi";
import { ErrorNotice, Loading, useRemote } from "components/admin/workspace/Controls";
import { useConfirm } from "components/ios/Alert";
import { hasCapability, useAdmin } from "components/admin/RequireAdmin";

// TMS catch-up (website launch L8, Ivan 2026-10-15): everything queued before the TMS link is switched on waits, held,
// until the owner checks the count and sends it once.
export default function LinkCatchUp() {
  const profile = useAdmin();
  const [tick, setTick] = useState(0), state = useRemote(hasCapability(profile, "link.catchup") ? "/admin/link/catch-up" : null, tick);
  const [dialog, ask] = useConfirm();
  const [busy, setBusy] = useState(false), [error, setError] = useState(null), [notice, setNotice] = useState("");
  const key = useRef(null);
  if (!hasCapability(profile, "link.catchup")) return null;
  const d = state.data;
  const send = async () => {
    if (busy || !d) return;
    const count = Math.min(d.held, 400);
    if (!(await ask({ title: "Send queued items to the TMS?", message: `${count} items queued before the TMS link was switched on will be sent now.`, confirm: "Send" }))) return;
    setBusy(true); setError(null); setNotice("");
    try {
      key.current ||= operationKey();
      const r = await adminRequest("/admin/link/catch-up", { method: "POST", key: key.current, body: { confirmed: true, expectedCount: count } });
      key.current = null; setNotice(`${r.data.released} items released to send.`); setTick((n) => n + 1);
    } catch (e) { setError(e); } finally { setBusy(false); }
  };
  return <section className="aw-panel" aria-labelledby="catch-up-title">
    {dialog}
    <h2 id="catch-up-title">Queued before the TMS link</h2>
    <ErrorNotice error={error} />{notice && <p className="aw-notice" role="status">{notice}</p>}
    <Loading state={state}>{d && <>
      <p>{d.held} items are waiting from before the TMS link was switched on{d.linkOn ? "." : ". The link is off; they wait until it is on."}</p>
      <button type="button" className="aw-button aw-primary" disabled={busy || !d.linkOn || !d.held} onClick={send}>{busy ? "Sending…" : "Send queued items"}</button>
    </>}</Loading>
  </section>;
}
